import type { EmailInboxMessage } from '@dcc-erp/shared';

// Email-source provenance card (M4). Renders in the review two-pane ONLY when
// the proposal carries a joined emailMessage. Trust chips = the persisted
// sender-trust verdict (senderTrusted, computed allowlist × SPF × DKIM) plus the
// raw SPF/DKIM results. prototype.css tokens only (.card / .badge / .muted).
function TrustChip({ ok, label }: { ok: boolean; label: string }) {
  return (
    <span className={`badge ${ok ? 'positive' : 'negative'}`} style={{ marginRight: 6 }}>
      {label} {ok ? '✓' : '✗'}
    </span>
  );
}

export function EmailSourcePanel({ email }: { email: EmailInboxMessage }) {
  return (
    <div className="card" style={{ padding: 12, display: 'grid', gap: 6 }}>
      <div style={{ fontWeight: 600 }}>ที่มา: อีเมล</div>
      <div className="muted" style={{ fontSize: 13 }}>
        จาก: <b>{email.fromAddress}</b>
      </div>
      <div className="muted" style={{ fontSize: 13 }}>
        เรื่อง: <span>{email.subject ?? '—'}</span>
      </div>
      <div className="muted" style={{ fontSize: 13 }}>
        รับเมื่อ: {email.receivedAt ? new Date(email.receivedAt).toLocaleString('th-TH') : '—'}
      </div>
      <div className="muted" style={{ fontSize: 12 }}>
        Message-Id: {email.rfc822MessageId ?? '—'}
      </div>
      <div style={{ marginTop: 4 }}>
        <TrustChip ok={email.senderTrusted} label="Allowlisted" />
        <TrustChip ok={email.spfPass} label="SPF" />
        <TrustChip ok={email.dkimPass} label="DKIM" />
      </div>
      {!email.senderTrusted && (
        <div className="muted" style={{ fontSize: 12, color: 'var(--negative)' }}>
          ผู้ส่งไม่อยู่ในรายชื่อที่เชื่อถือ หรือการตรวจสอบความถูกต้องไม่ผ่าน —
          เอกสารจะเข้าสู่การอนุมัติ 4 ตา
        </div>
      )}
    </div>
  );
}
